import React from "react"
import styled from "styled-components"

const StyledVideo = styled.div`
  margin-top: 0.8rem;
  border: 1px solid #0B2540;
  border-radius: 0.3rem;
  iframe {
    border-radius: 0.3rem 0.3rem 0 0;
    height: 13rem;
  }
  .text {
    color: #6485A8;
    font-size: 0.95rem;
    line-height: 1.3rem;
    padding: 1rem;
    text-align: left;
  }
`

const Video = ({ url, text }) => (
  <StyledVideo>
    <iframe width="100%" height="100%" src={url} frameBorder="0" allowFullScreen></iframe>
    <div className="text">
     {text}
    </div>
  </StyledVideo>
)


export default Video
